import { render, staticRenderFns } from "./Monitors-Yaml-Modal.vue?vue&type=template&id=388024a7&lang=pug"
import script from "./Monitors-Yaml-Modal.vue?vue&type=script&lang=ts"
export * from "./Monitors-Yaml-Modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports